import { FC, HTMLAttributes } from "react";
import { map } from "lodash-es";
import { useStyles } from "./ProfileStats.styles";
import { StatCard, StatCardLoading } from "../StatCard";
import GZIcon from "../../../assets/icon/gamezone_coin/gamezone_coin_1x.webp";
import GZIcon2x from "../../../assets/icon/gamezone_coin/gamezone_coin_2x.webp";
import GZIcon3x from "../../../assets/icon/gamezone_coin/gamezone_coin_3x.webp";
import DailyStreakIcon from "../../../assets/icon/daily_streak/daily_streak_1x.webp";
import DailyStreakIcon2x from "../../../assets/icon/daily_streak/daily_streak_2x.webp";
import DailyStreakIcon3x from "../../../assets/icon/daily_streak/daily_streak_3x.webp";
import { CoinType, CoinWallet, User, Transaction } from "@onmo/graphql/graphql";
import { useTranslation } from "react-i18next";
import { Typography } from "../../core/Typography/Typography";
import {
  TypographyVariant,
  TypographyColor,
} from "../../../constants/typography";
import { TransactionHistoryCard } from "../TransactionHistoryCard";
import { groupByDateReward } from "../../../models/rewardHistory";

interface IProfileStatsProps {
  profile?: User;
  wallet?: Array<CoinWallet>;
  rewardsHistory?: Transaction[];
}
export const ProfileStats: FC<
  HTMLAttributes<HTMLDivElement> & IProfileStatsProps
> = ({ profile, wallet, rewardsHistory }) => {
  const classes = useStyles();
  const { t } = useTranslation();
  const rewards = groupByDateReward(rewardsHistory);

  if (!profile)
    return (
      <div className={classes.root}>
        {Array.from(new Array(6)).map((_, idx) => (
          <StatCardLoading key={idx} />
        ))}
      </div>
    );

  const getGZCoins = () => {
    return (
      wallet?.find((wal) => wal.itemType === CoinType.GzTokens)?.balance || 0
    );
  };

  return (
    <div className={classes.root}>
      <StatCard
        statName={t("common_Coins Collected")}
        statContent={getGZCoins()}
        icons={{ src: GZIcon, src2x: GZIcon2x, src3x: GZIcon3x }}
      />
      <StatCard
        statName={t("common_Daily Streak")}
        statContent={profile?.loginStreak}
        icons={{
          src: DailyStreakIcon,
          src2x: DailyStreakIcon2x,
          src3x: DailyStreakIcon3x,
        }}
      />
      {Object.keys(rewards)?.length > 0 && (
        <div className={classes.transactionHistory}>
          <Typography
            variant={TypographyVariant.BodyB5Medium}
            color={TypographyColor.Disable}
          >
            {t("common_Reward History")}
          </Typography>
          <div className={classes.content}>
            {map(Object.keys(rewards), (dateTime) => (
              <div className={classes.htDate} key={dateTime}>
                <Typography variant={TypographyVariant.BodyB5Medium}>
                  {dateTime}
                </Typography>
                {map(rewards[dateTime], (rw) => (
                  <TransactionHistoryCard
                    rewardsHistory={rw}
                    className={classes.htCard}
                    key={rw?.id}
                  />
                ))}
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  );
};
